export const CANNOT_DELETE_ROLE_MESSAGE = "This role cannot be deleted";

export function roleCanBeDeleted(role: { canDelete?: boolean } | null | undefined): boolean {
  return role?.canDelete !== false;
}
